import {getCookie, setCookie} from 'custom-extensions/cookies';
import {v4 as uuidv4} from 'uuid';

export class SearchSpringBaseService {
	uid () {
		return uuidv4();
	}

	getUser () {
		const ssCookiename = 'ssUserId';
		let uuid = getCookie(ssCookiename);

		if (!uuid) {
			uuid = this.uid();
			setCookie(ssCookiename, uuid, 365);
		}

		return uuid;
	};

	getSessionID () {
		const ssCookiename = 'ssSessionIdNamespace';
		let sessionId = sessionStorage.getItem(ssCookiename);

		if (!sessionId) {
			sessionId = this.uid();
			sessionStorage.setItem(ssCookiename, sessionId);
		}

		return sessionId;
	}
};
